// extracted by mini-css-extract-plugin
export var alignCenter = "_8u-d";
export var bannerShown = "_8u-6";
export var buttonContent = "_8u-0";
export var cardList = "_8u-1";
export var centerContent = "_8u-2";
export var chevron = "_8u-3";
export var closePanelButton = "_8u-k";
export var conversationContextContainer = "_8u-l";
export var conversationDetailContainer = "_8u-4";
export var detailWrapper = "_8u-7";
export var dropdownButton = "_8u-e";
export var dropdownTitle = "_8u-9";
export var fullHeight = "_8u-5";
export var hidden = "_8u-a";
export var icon = "_8u-b";
export var mergeSuggestionWrapper = "_8u-m";
export var panel = "_8u-i";
export var portalButtonsWrapper = "_8u-c";
export var right = "_8u-j";
export var tableSummaryContainer = "_8u-8";
export var tableSummaryHeader = "_8u-g";
export var threeDotsButton = "_8u-f";
export var wide = "_8u-h";